





import { Component, Vue } from 'vue-property-decorator';

@Component
export default class delivery extends Vue {
  created() {}
}
